module.exports = __webpack_public_path__ + "media/images/levelup_crown_silver-5850637ce735e0b7e2190e726daac59d.png";